import { NgModule } from "@angular/core";
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { AppConstants } from './app.constants';
import { LoginComponent } from './components/shared/login/login.component';
import { ResolverloginService } from './services/resolverlogin.service';
import { ResolverService } from './services/resolver.service';
import { VerifyAccessComponent } from "./components/shared/verify-access/verify-access.component";
import { ErrorComponent } from "./components/error/error.component";
import { ResultadosPublicoComponent } from "./components/shared/resultados-publico/resultados-publico.component";

const routes: Routes = [
    { path: AppConstants.APLICATION_MODULES.LOGIN.ruta, component: LoginComponent, resolve: { validateLogin: ResolverloginService } },
    { path: AppConstants.APLICATION_MODULES.INICIO.ruta, component: HomeComponent, resolve: { validateLogin: ResolverService } },
    { path: AppConstants.APLICATION_MODULES.ERROR.ruta, component: ErrorComponent, resolve: { validateLogin: ResolverService } },
    { path: AppConstants.APLICATION_MODULES.VOTACIONES.ruta, loadChildren: () => import('./components/votaciones/votaciones.module').then(m => m.VotacionesModule) },
    { path: AppConstants.APLICATION_MODULES.CONFIGURACION.ruta, loadChildren: () => import('./components/configuracion/configuracion.module').then(m => m.ConfiguracionModule) },
    { path: AppConstants.APLICATION_MODULES.VERIFICAR_ACCESO.ruta, component: VerifyAccessComponent, resolve: { validateLogin: ResolverloginService } },
    { path: AppConstants.APLICATION_MODULES.RESULTADOS_PUBLICO.ruta, component: ResultadosPublicoComponent },
    { path: '**', pathMatch: 'full', redirectTo: AppConstants.APLICATION_MODULES.INICIO.ruta }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: []
})
export class AppRoutingModule { }